module.exports = __webpack_public_path__ + "static/media/glass4.d6e752c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass4.png
// module id = 729
// module chunks = 0